import { IllustrativeIcon, Surface, Txt } from '@vst/beam';
import { HelpCenter } from '@vst/beam-icons/illustrative-icons';
import { useTranslation } from 'react-i18next';

import { CustomStandardModal } from '@app/components/Modal';

import styles from '../../index.module.scss';

type CancelSignEcaModalProps = {
  isOpen: boolean;
  isServiceable?: boolean;
  handleBack: () => void;
  handleExit: () => void;
};

export const CancelSignEcaModal = ({ isOpen, handleBack, handleExit, isServiceable }: CancelSignEcaModalProps) => {
  const { t } = useTranslation('SignContract');

  return (
    <CustomStandardModal
      isOpen={isOpen}
      size={'medium'}
      header={null}
      actions={{
        primary: {
          label: t('cancelModal.exit'),
          onClick: handleExit,
          minWidth: '140px',
          'data-cy': 'cancel-sign-eca-exit',
        },
        secondary: {
          label: t('cancelModal.goBack'),
          onClick: handleBack,
          minWidth: '140px',
          'data-cy': 'cancel-sign-eca-go-back',
        },
      }}
      onClose={handleBack}
      data-cy={'cancel-sign-eca-modal'}
      surfaceProps={{ className: styles['modal-content'] }}
    >
      <div>
        <IllustrativeIcon icon={HelpCenter} color={'teal_600'} size={'96px'} mb={'24px'} data-cy={'help-center-icon'} />
        <Txt variant={'heading4'} mb={'16px'} data-cy={'cancel-sign-eca-header'}>
          {t('cancelModal.header')}
        </Txt>
        <Txt variant={'bodyLargeRegular'} color={'subtle'} data-cy={'cancel-sign-eca-message'}>
          {isServiceable ? t('cancelModal.serviceableMessage') : t('cancelModal.nonServiceableMessage')}
        </Txt>
      </div>
    </CustomStandardModal>
  );
};
